import getApiClient from '@/plugins/api-client'
import { parseFilters } from '@/util/helpers'

export default {
  loadSpecializations: function () {
    const api = getApiClient(this.$store)

    const params = parseFilters({
      ...this.pagination.getParams(),
    })

    api.get('specializations', { params })
      .then(result => {
        this.specializations = result.data['hydra:member']
        this.pagination.updateData(result.data)
      })
      .catch(error => {
        this.error = error
      })
  },

  askDelete (modalityId) {
    this.showDeleteDialog = true
    this.deletingId = modalityId
  },

  cancelDelete () {
    this.showDeleteDialog = false
    this.deletingId = null
  },

  confirmDelete () {
    if (!this.deletingId) {
      return
    }

    const api = getApiClient(this.$store)

    api.delete(this.deletingId)
      .then(result => {
        if (result.status === 204) {
          this.$store.commit('app/raiseSuccess', 'Especialização excluída')
          this.loadSpecializations()
        }
      })
      .catch(() => {
        this.$store.commit('app/raiseError', 'Erro ao excluir especialização')
        this.loadSpecializations()
      })
      .finally(() => {
        this.cancelDelete()
      })
  },
}
